import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

import type { SnowFlakePolicyRangeStatusEnum } from '~/graphql/pp/generated/graphql';

export const useRentersGlobal = () => {
  const yersterday = dayjs().subtract(1, 'day');
  const defaultStartDate = yersterday.add(-1, 'year');
  const defaultEndDate = yersterday;

  const startDate = useState<Dayjs>('rentersStartDate', () => defaultStartDate);
  const endDate = useState<Dayjs>('rentersEndDate', () => defaultEndDate);
  const rangeStatus = useState<SnowFlakePolicyRangeStatusEnum[] | undefined>('rentersRangeStatus');
  const purchaseInRange = useState<boolean>('rentersPurchaseInRange');
  const activeInRange = useState<boolean>('rentersActiveInRange');

  const dates = computed(() => ({
    start_date: startDate.value.format('YYYY-MM-DD'),
    end_date: endDate.value.format('YYYY-MM-DD'),
  }));
  const datesPrev = computed(() => ({
    start_date: startDate.value?.add(-1, 'year').format('YYYY-MM-DD'),
    end_date: endDate.value?.add(-1, 'year').format('YYYY-MM-DD'),
  }));

  const onUpdateDates = (newStartDate: Dayjs, newEndDate: Dayjs) => {
    startDate.value = newStartDate;
    endDate.value = newEndDate;
  };

  const onUpdateRangeStatus = (values?: SnowFlakePolicyRangeStatusEnum[]) => {
    rangeStatus.value = values;
  };

  const onUpdate = (
    newStartDate: Dayjs,
    newEndDate: Dayjs,
    purchaseInRangeValue: boolean,
    activeInRangeValue: boolean,
    rangeStatuses?: SnowFlakePolicyRangeStatusEnum[],
  ) => {
    onUpdateDates(newStartDate, newEndDate);
    onUpdateRangeStatus(rangeStatuses);
    purchaseInRange.value = purchaseInRangeValue;
    activeInRange.value = activeInRangeValue;
  };

  const setValidStartDate = (date?: string) => {
    if (date) {
      const effectiveDate = dayjs(date);
      if (effectiveDate.isBefore(endDate.value)) {
        startDate.value = effectiveDate;
      }
    }
  };

  return {
    defaultStartDate,
    defaultEndDate,
    startDate,
    endDate,
    dates,
    datesPrev,
    setValidStartDate,
    onUpdateDates,
    rangeStatus,
    onUpdateRangeStatus,
    purchaseInRange,
    onUpdatePurchaseInRange: (value: boolean) => { purchaseInRange.value = value; },
    activeInRange,
    onUpdateActiveInRange: (value: boolean) => { activeInRange.value = value; },
    onUpdate,
  };
};

export type UseRentersGlobal = ReturnType<typeof useRentersGlobal>;
